<div [ngClass]="currentModuleClassName()"></div>
